// The `analytics` interface: what the app counts about its own use, and
// nothing about where the counts go. A plugin asks `getApi('analytics')`
// and calls `page` or `track`; the provider (shared-analytics today) decides
// whether anything leaves the browser at all (a stream for this hostname, no
// Do Not Track, the script loaded) and sends it. Nothing identifying is ever
// passed: a path without ids or usernames, an event name in snake_case, a
// few small parameters.

export const ANALYTICS_API = 'analytics';
export const ANALYTICS_VERSION = '1.0.0';

export type AnalyticsValue = string | number | boolean;

export interface Analytics {
  /** A screen shown: its path without query or fragment (no game ids, no usernames). */
  page(path: string): void;
  /** Something that happened; names in snake_case, a few small parameters, nothing identifying. */
  track(event: string, params?: Record<string, AnalyticsValue>): void;
  /** Whether events leave the browser at all (a stream for this hostname, and the script loaded). */
  enabled(): boolean;
}
